import React, { Component } from 'react';

import S3 from 'aws-sdk/clients/s3';
import { pickHex, getBodyThemeColors, getTheme } from 'util/colors';
import { convertGalleryIdToName } from 'util/gallery';

import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import LazyImage from 'components/LazyImage';
import Loading from 'components/Loading';
import Waypoint from 'react-waypoint';

import './index.css';

const Bucket = 'ebenbitonte.com';
const s3 = new S3({
    credentials: {
        accessKeyId: 'AKIAJUYCWFZYY223VGFQ',
        secretAccessKey: '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'
    },
    region: 'us-east-1'
});

const LAZY_LOAD_AT_A_TIME = 20;

export default class Gallery extends Component {
    constructor(props) {
        super(props);

        const gallery = this.props.match.params.gallery;
        const galleryName = convertGalleryIdToName(gallery);

        this.state = {
            photos: [],
            renderedPhotos: [],
            gallery,
            galleryName
        }

        this.addNextBatch = this.addNextBatch.bind(this);
    }

    componentDidMount() {
        fetchPhotosForAlbum(this.state.gallery, photos => this.setState({
            photos,
            renderedPhotos: photos.slice(0, LAZY_LOAD_AT_A_TIME)
        }));
    }

    addNextBatch() {
        const {
            photos,
            renderedPhotos
        } = this.state;

        this.setState({
            renderedPhotos: photos.slice(0, renderedPhotos.length + LAZY_LOAD_AT_A_TIME)
        });
    }

    render() {
        const { match } = this.props;

        const {
            galleryName,
            photos,
            renderedPhotos
        } = this.state;

        const {
            topColor,
            bottomColor
        } = getBodyThemeColors();

        const renderedPhotosComponents = renderedPhotos.map((photo, i) => (
            <Link
                key={i}
                to={{
                    pathname: `/gallery/${match.params.gallery}/img/${encodeURIComponent(photo)}`,
                    state: { modal: true }
                }}
            >
                <LazyImage
                    src={photo}
                    placeholderColor={pickHex(bottomColor, topColor, i / photos.length)}
                />
            </Link>
        ));

        const mainGalleryComponents = photos.length ? (
            <React.Fragment>
                {renderedPhotosComponents}
                <Waypoint onEnter={this.addNextBatch} />
            </React.Fragment>
        ) : null;

        const loadingIndicator = (renderedPhotos.length !== photos.length) || !renderedPhotos.length
            ? <Loading theme={getTheme()} />
            : null;

        return (
            <main className='Gallery-container'>
                <Helmet>
                    <title>{galleryName}</title>
                    <meta property='og:title' content={galleryName} />
                    <meta property='og:image' content={photos[0]} />
                    <meta name="twitter:card" content={photos[0]} />
                </Helmet>
                <h1 className='Gallery-header'>{galleryName}</h1>
                <div className='Gallery-images'>
                    {mainGalleryComponents}
                    {loadingIndicator}
                </div>
            </main>
        );
    }
}

function fetchPhotosForAlbum(albumName, callback) {
    const Prefix = encodeURIComponent(albumName) + '/';

    s3.listObjects({ Bucket, Prefix }, function(err, data) {
        if (err) {
            return;
        }

        const href = this.request.httpRequest.endpoint.href;
        const bucketUrl = `${href}${Bucket}/`;

        const photos = data.Contents
            .filter(photo => photo.Key !== Prefix)
            .map(photo => `${bucketUrl}${encodeURIComponent(photo.Key)}`);

        callback(photos);
    })
}



// WEBPACK FOOTER //
// ./src/containers/Gallery/index.js